import React from 'react';
import { observer } from 'mobx-react';
import LangSelectorComponent from './Lang-selector.component';
import useLangSelector from './useLangSelector';

const Container = () => {
    const { lang, handlers } = useLangSelector();

    return (
        <>
            <LangSelectorComponent
                lang={lang.lang}
                languages={lang.languages}
                langMap={lang.langMap}
                onLangClick={handlers.handleLangClick}
            />
        </>
    );
};

const LangSelectorContainer = observer(Container);

export default LangSelectorContainer;
